import { faComment } from "@fortawesome/pro-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GREEN } from "theme/colors";

import { ActionButton } from "../CalendarCard/CalendarCard";

interface CommentButtonProps {
  hasReply: boolean;
  onClick: () => void;
}

export const CommentButton: React.FC<CommentButtonProps> = ({ hasReply, onClick }) => {
  const { t } = useTranslation();

  return (
    <ActionButton
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      $variant="secondary"
      title={t("treatment.editor.view_comment")}
    >
      <Box sx={{ position: "relative" }}>
        <FontAwesomeIcon icon={faComment} />
        {hasReply && (
          <FontAwesomeIcon
            icon={faCircleCheck}
            color={GREEN[100]}
            style={{ position: "absolute", bottom: -4, right: -4 }}
          />
        )}
      </Box>
    </ActionButton>
  );
};
